'use client';

import { useCallback, useState } from 'react';
import type { TraitExplanationEntry } from './ebvTraitExplanations';

export function useEbvTraitExplanationPopover() {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);
  const [popoverEntry, setPopoverEntry] =
    useState<TraitExplanationEntry | null>(null);

  const openPopover = Boolean(popoverAnchor);

  const handleInfoClick = useCallback(
    (event: React.MouseEvent<HTMLElement>, entry: TraitExplanationEntry) => {
      event.stopPropagation();
      setPopoverAnchor(event.currentTarget);
      setPopoverEntry(entry);
    },
    [],
  );

  const handlePopoverClose = useCallback(() => {
    setPopoverAnchor(null);
    setPopoverEntry(null);
  }, []);

  return {
    popoverAnchor,
    popoverEntry,
    openPopover,
    handleInfoClick,
    handlePopoverClose,
  };
}
